// extracted by mini-css-extract-plugin
export default {"tabs":"HttpMonitorTabs_tabs__d6WU-"};